import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackContextFieldEdited.meta';

export type UseTrackContextFieldEditedParams = {
  source: 'manual';
  field_name: string;
  edit_type: 'renamed' | 'instructions_edited';
  new_name?: string;
};

export const useTrackContextFieldEdited = () => {
  const { track } = useAnalyticsUtilities();

  const trackContextFieldEdited = useCallback(
    (params: UseTrackContextFieldEditedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackContextFieldEdited };
};
